import { RefundTablePage } from "./refundTable/RefundTablePage";
import { RefundFilterPage } from "./refundFilter/RefundFilterPage";

import classes from "./refundPage.module.css";

export const RefundPage = () => {
  return (
    <div className={classes.box}>
      <RefundFilterPage />
      <RefundTablePage />
    </div>
  );
};
